import axios from 'axios';

const initialState = {
  defaultEmail: null,
  error: null,
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setError(state, error) {
      state.error = error;
    },
    setDefaultEmail(state, defaultEmail) {
        state.defaultEmail = defaultEmail;
    }
  },
  getters: {
    hasError(state) {
      return !!state.error;
    },
  },
  actions: {
    async getDefaultEmailSender({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/email/sender/default`,
        );

        commit('setDefaultEmail', response.data );
      } catch (error) {
        if (error.data && error.data.error) {
          commit('setError', error.data.error);
          return;
        }

        commit('setError', error);
      }
    },
    async setDefaultEmailSender({ commit }, payload) {
        try {
          const response = await axios.post(
            `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/email/sender/default`,
            payload,
          );
  
          commit('setDefaultEmail', { ...payload, ...response.data} );
        } catch (error) {
          if (error.data && error.data.error) {
            commit('setError', error.data.error);
            return;
          }
  
          commit('setError', error);
        }
      },
  },
};
